module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "th1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("Key Lime Blanket")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "hleft"
  }, [_c('span', {
    staticClass: "litgreen"
  }, [_vm._v("This simple, fresh baby blanket is created by combining two-by-two rib and Garter stitch in concentric circles. Worked from the center outward, all the increases occur on knit rounds, which makes the counting easy to manage. The off-white center and border mimic the look of a sliced lime.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("FINISHED MEASUREMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("36\" diameter")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("YARN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("Berroco Vintage Chunky (50% acrylic / 40% wool / 10% nylon; 100 grams / 130 yards): 6 hanks #6124 Kiwi (MC); 2 hanks #6101 Mochi (A)")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("NEEDLES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("One 36\" (90 cm) long circular (circ) needle size US 10 (6 mm)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("One set of five double-pointed needles (dpn) size US 10 (6 mm)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("NOTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("Stitch marker")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("GAUGE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "litpink"
  }, [_vm._v("14 sts and 21 rows = 4\" (10 cm) in Stockinette stitch (St st)")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litgreen"
  }, [_vm._v("BLANKET")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Using dpns and A, CO 8 sts. Divide sts evenly among 4 dpns.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Join for working in the rnd; pm for beginning of rnd.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("Note: Change to circ needle when necessary for number of sts on needles.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 1:")]), _vm._v(" *K1-tbl; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 2:")]), _vm._v(" *K1, M1; repeat from * to end—16 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 3:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 4:")]), _vm._v(" Repeat Rnd 2—32 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 5:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 6:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 7:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 8:")]), _vm._v(" *K2, M1; repeat from * to end—48 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 9 and 11:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 10 and 12:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 13:")]), _vm._v(" *K4, M1; repeat from * to end—60 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 14-18:")]), _vm._v(" *K2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 19:")]), _vm._v(" Change to MC; knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 20:")]), _vm._v(" *K15, M1; repeat from * to end—64 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 21:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 22:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 23:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 24:")]), _vm._v(" *K2, M1; repeat from * to end—96 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 25-29:")]), _vm._v(" *K2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 30:")]), _vm._v(" *K3, M1; repeat from * to end—128 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 31:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 32:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 33:")]), _vm._v(" Purl.")])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('b', [_vm._v("Rnd 34:")]), _vm._v(" *K4, M1; repeat from * to end—160 sts.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 35-41:")]), _vm._v(" *K2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 42:")]), _vm._v(" *K5, M1; repeat from * to end—192 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 43:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 44:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 45:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 46:")]), _vm._v(" *K6, M1; repeat from * to end—224 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 47-55:")]), _vm._v(" *K2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 56:")]), _vm._v(" *K7, M1; repeat from * to end—256 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 57:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 58:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 59:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 60:")]), _vm._v(" *K8, M1; repeat from * to end—288 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 61-71:")]), _vm._v(" *K2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 72:")]), _vm._v(" *K9, M1; repeat from * to end—320 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 73:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 74:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 75:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 76:")]), _vm._v(" *K10, M1; repeat from * to end—352 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 77-89:")]), _vm._v(" *K2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 90:")]), _vm._v(" *K11, M1; repeat from * to end—384 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 91:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 92:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 93:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 94:")]), _vm._v(" *K12, M1; repeat from * to end—416 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 95-109:")]), _vm._v(" *K2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnds 110-116:")]), _vm._v(" Change to A; *k2, p2; repeat from * to end.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 117:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 118:")]), _vm._v(" Purl.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 119:")]), _vm._v(" Knit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Rnd 120:")]), _vm._v(" Purl. BO all sts knitwise.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litgreen"
  }, [_vm._v("FINISHING")])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Block lightly (see Special Techniques, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/55_Special_Techniques#page_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 156")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "img_center1"
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_013.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-058b6a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter02.vue
// module id = 75
// module chunks = 0